module.exports = __webpack_public_path__ + "img/image.58f01911.png";